<template>
  <validation-observer #default="{ handleSubmit }" ref="memberProfileForm">
    <form @submit.prevent="handleSubmit(() => onCreateOrUpdate())">
      <b-row class="mt-1">
        <b-col cols="12" md="6">
          <validation-provider
            #default="{ errors }"
            name="Member Type"
            rules="required"
          >
            <b-form-group label="Member Type" label-for="member_type">
              <template #label>
                <span>Member Type<sup style="color: tomato">*</sup></span>
              </template>

              <v-select
                id="member_type"
                v-model="memberProfile.member_type_id"
                placeholder="Member type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="memberTypeOptions"
                :reduce="(val) => val.value"
                :disabled="loading"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Member Status" label-for="member_status">
            <template #label>
              <span>Member Status<sup style="color: tomato">*</sup></span>
            </template>

            <validation-provider
              #default="{ errors }"
              name="Member Status"
              rules="required"
            >
              <v-select
                v-model="memberProfile.member_status_id"
                placeholder="Member Status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="memberStatusOptions"
                :reduce="(val) => val.value"
                :disabled="loading"
              />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>

      <div v-if="country === 'Ghana'">
        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <b-form-group label="Region" label-for="region">
              <template #label>
                <span>Region<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Region"
                rules="required"
              >
                <v-select
                  id="region"
                  v-model="memberProfile.region_id"
                  placeholder="Region"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="regionOptions"
                  :reduce="(val) => val.value"
                  :disabled="loading"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group label="Area" label-for="area">
              <template #label>
                <span>Area<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Area"
                rules="required"
              >
                <v-select
                  id="area"
                  v-model="memberProfile.area_id"
                  placeholder="Area"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="areaOptions"
                  :reduce="(val) => val.value"
                  :disabled="loading"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <b-form-group label="District" label-for="district">
              <template #label>
                <span>District<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="District"
                rules="required"
              >
                <v-select
                  id="district"
                  v-model="memberProfile.district_id"
                  placeholder="District"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="districtOptions"
                  :reduce="(val) => val.value"
                  :disabled="loading"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group label="Assembly" label-for="assembly">
              <template #label>
                <span>Assembly</span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Assembly"
              >
                <v-select
                  id="assembly"
                  v-model="memberProfile.assembly_id"
                  placeholder="Assembly"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="assemblyOptions"
                  :reduce="(val) => val.value"
                  :disabled="loading"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div v-else>
        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              name="Region"
              rules="required"
            >
              <b-form-group label="Region" label-for="region">
                <template #label>
                  <span>Region<sup style="color: tomato">*</sup></span>
                </template>

                <b-form-input
                  id="region"
                  v-model="memberProfile.region"
                  placeholder="Region"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group label="Area" label-for="area">
              <template #label>
                <span>Area<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Area"
                rules="required"
              >
                <b-form-input
                  id="area"
                  v-model="memberProfile.area"
                  placeholder="Area"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <b-form-group label="District" label-for="district">
              <template #label>
                <span>District<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="District"
                rules="required"
              >
                <b-form-input
                  id="district"
                  v-model="memberProfile.district"
                  placeholder="District"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6">
            <b-form-group label="Assembly" label-for="assembly">
              <template #label>
                <span>Assembly<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Assembly"
                rules="required"
              >
                <b-form-input
                  id="assembly"
                  v-model="memberProfile.assembly"
                  placeholder="Assembly"
                  :disabled="disableForm"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        size="lg"
        class="mr-2 mb-5"
        :disabled="disableForm"
        type="submit"
      >
        Save
      </b-button>
    </form>
  </validation-observer>
</template>

<script>
import { get } from "lodash";
import Cleave from "vue-cleave-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BOverlay,
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAvatar,
  BFormTextarea,
  BFormInvalidFeedback,
  BButton,
  BFormFile,
  BFormCheckbox,
  BAlert,
  BCardText,
  BModal,
  BMedia,
  BMediaBody,
  BMediaAside,
  BImg,
  BTabs,
  BTab,
  BCard,
  BFormDatepicker,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

export default {
  name: "MemberProfileUpdate",
  components: {
    vSelect,
    Cleave,
    BOverlay,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAvatar,
    BFormTextarea,
    BFormInvalidFeedback,
    BButton,
    BFormFile,
    BFormCheckbox,
    BAlert,
    BCardText,
    BModal,
    BMedia,
    BMediaBody,
    BMediaAside,
    BImg,
    BTabs,
    BTab,
    BCard,
    BFormDatepicker,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    disableForm: {
      type: Boolean,
      default: false,
    },
    countryOptions: {
      type: Array,
      default: () => [],
    },
    memberStatusOptions: {
      type: Array,
      default: () => [],
    },
    memberTypeOptions: {
      type: Array,
      default: () => [],
    },
    country: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      loading: false,
      memberProfile: {
        member_type_id: "",
        member_status_id: "",
        region_id: "",
        area_id: "",
        district_id: "",
        assembly_id: ""
      },
      cleaveDateOptions: {
        date: true,
        raw: true,
        delimiter: "-",
        datePattern: ["Y", "m", "d"],
        blocks: [4, 2, 2],
      },
      regionOptions: [],
      areaOptions: [],
      districtOptions: [],
      assemblyOptions: [],
    };
  },
  watch: {
    "memberProfile.region_id": {
      handler(changed) {
        if (changed) {
          if (changed !== this.initialValues.region_id) {
            this.memberProfile.area_id = "";
            this.memberProfile.district_id = "";
            this.memberProfile.assembly_id = "";
          }
          this.fetchChurchAreas();
        }
      },
      immediate: true,
    },
    "memberProfile.area_id": {
      handler(changed) {
        if (changed) {
          if (changed !== this.initialValues.area_id) {
            this.memberProfile.district_id = "";
            this.memberProfile.assembly_id = "";
          }
          this.fetchChurchDistrict();
        }
      },
      immediate: true,
    },
    "memberProfile.district_id": {
      handler(changed) {
        if (changed) {
          if (changed !== this.initialValues.district_id) {
            this.memberProfile.assembly_id = "";
          }
          this.fetchChurchAssemblies();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.memberProfile = { ...this.initialValues };
    console.log(this.memberProfile);
    this.fetchChurchRegions();
  },
  methods: {
    async onCreateOrUpdate(form_to_validate) {
      try {
        if (form_to_validate) {
          const success = await this.$refs.personalForm.validate();
          if (!success) {
            this.toast({
              title: "Error!",
              icon: "AlertQuestionIcon",
              variant: "warning",
              text: `Member updated successfully`,
            });
            return;
          }
        }
        this.loading = true;
        this.errorMessage = "";

        const messages = {
          update: {
            title: "Confirm Member Update",
            text: "Do you want to update this member?",
            icon: "warning",
          },
        };

        /* eslint-disable no-nested-ternary */
        const message = messages.update;
        const { title, text, icon } = message;

        const result = await this.$swal({
          title,
          text,
          icon,
          showCancelButton: true,
          confirmButtonText: "Yes, proceed.",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        });
        if (!result.isConfirmed) {
          return;
        }

        await this.useJwt().mainService.memberProfiles.updateMemberProfile(
          this.$route.params.id,
          this.memberProfile
        );

        this.$emit("refetchData");
        this.$emit("update:is-add-or-update-active", false);

        this.toast({
          title: "Success!",
          icon: "AlertQuestionIcon",
          variant: "success",
          text: `Member updated successfully`,
        });
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        this.errorMessage = error_message;

        this.toast({
          title: "Success!",
          icon: "AlertQuestionIcon",
          variant: "success",
          text: `Member updated successfully`,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchRegions() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoRegions();
        const { data } = request.data;
        this.regionOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          title: "Error!",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: error_message,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAreas() {
      try {
        this.loading = true;

        const { region_id } = this.memberProfile;

        if (!region_id) {
          return;
        }
        const request = await this.useJwt().sharedService.fetchGeoAreas(
          { region_id }
        );
        const { data } = request.data;
        this.areaOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          title: "Error!",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: error_message,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchDistrict() {
      try {
        this.loading = true;

        const { area_id } = this.memberProfile;
        if (!area_id) {
          return;
        }

        const request = await this.useJwt().sharedService.fetchGeoDistricts(
          { area_id }
        );
        const { data } = request.data;
        this.districtOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          title: "Error!",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: error_message,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAssemblies() {
      try {
        this.loading = true;

        if (!this.memberProfile.district_id) {
          return;
        }

        const request = await this.useJwt().sharedService.fetchGeoAssemblies(
          { district_id: this.memberProfile.district_id }
        );
        const { data } = request.data;
        this.assemblyOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.toast({
          title: "Error!",
          icon: "AlertTriangleIcon",
          variant: "danger",
          text: error_message,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
